// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__76lwW","modalFooterButton":"ModalNotes_modalFooterButton__192pz"};